import { create } from 'zustand';

export type DealBuilderAlertInput = {
  snackMessage: string | undefined,
  setSnackMessage: (message: string | undefined) => void,
  
  hiddenYieldUpdate: boolean,
  setHiddenYieldUpdate: (hiddenYieldUpdate: boolean) => void,

  hiddenSimilarDealsAlert: boolean,
  setHiddenSimilarDealsAlert: (hiddenSimilarDealsAlert: boolean) => void,
}

const useDealBuilderAlertsStore = create<DealBuilderAlertInput>((set) => ({
  snackMessage: undefined,
  setSnackMessage: (snackMessage: string | undefined) => set({ snackMessage }),
  
  hiddenYieldUpdate: false,
  setHiddenYieldUpdate: (hiddenYieldUpdate: boolean) => set({ hiddenYieldUpdate }),

  hiddenSimilarDealsAlert: false,
  setHiddenSimilarDealsAlert: (hiddenSimilarDealsAlert: boolean) => set({ hiddenSimilarDealsAlert }),
}));

export default useDealBuilderAlertsStore;
